import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/report/yearToDateChannelPartnerCommitmentVsShipped'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  yearToDateChannelPartnerCommitmentVsShipped: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  yearToDateChannelPartnerCommitmentVsShipped: state => state.yearToDateChannelPartnerCommitmentVsShipped
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED = 'REQUEST_GET_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED'
const RECEIVE_GET_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED = 'RECEIVE_GET_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getYearToDateChannelPartnerCommitmentVsShipped ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting yearToDateChannelPartnerCommitmentVsShipped', { root: true })
    commit(REQUEST_GET_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveYearToDateChannelPartnerCommitmentVsShipped', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting yearToDateChannelPartnerCommitmentVsShipped', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting yearToDateChannelPartnerCommitmentVsShipped', { root: true })
        return Promise.reject(error)
      })
  },
  receiveYearToDateChannelPartnerCommitmentVsShipped ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED`, extract(json))
    return json.data
  },
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED](state, id) {
  },
  [RECEIVE_GET_YEAR_TO_DATE_CHANNEL_PARTNER_COMMITMENT_VS_SHIPPED](state, json) {
    state.yearToDateChannelPartnerCommitmentVsShipped = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
